import Head from 'next/head'
import React, { createContext, FC, useContext, useEffect, useState } from 'react'

type ContextType = {
  setTitle: (t: string) => void
}

const HtmlMetaContext = createContext<ContextType>({
  setTitle: () => {
    /* do nothing */
  }
})

const HtmlMetaProvider: FC = (props) => {
  const applicationName = 'Onetap配車'
  const [title, setTitle] = useState<string>()

  useEffect(() => {
    setTitle(null)
  }, [])

  return (
    <HtmlMetaContext.Provider value={{ setTitle }}>
      <Head>
        {/* HubSpot */}
        <script
          type="text/javascript"
          id="hs-script-loader"
          async
          defer
          src="//js.hs-scripts.com/5661351.js"></script>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
        <link rel="manifest" href="/favicons/site.webmanifest" />
        <link rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#2d89ef" />
        <meta name="theme-color" content="#f8f8f8" />
        <title>{title ? `${title} - ${applicationName}` : applicationName}</title>
      </Head>
      {props.children}
    </HtmlMetaContext.Provider>
  )
}

const useHtmlMeta = (): ContextType => useContext(HtmlMetaContext)

export { HtmlMetaProvider, useHtmlMeta }
